import { AxiosRequestConfig } from "axios";

import * as HttpHandler from "./httpHandler";
import { log } from "./logger";

export const Handlers = {
	authError: (message: string) => {
		log(message, "error");
	},
};

/** Make a POST request to the TLP server */
// oxlint-disable-next-line typescript/no-unnecessary-type-parameters -- callers pass explicit <TOut, TIn> type arguments
export async function Post<TOut, TIn = any>(
	controller: string,
	action: string,
	params: object | string = {},
	data?: TIn,
	config?: AxiosRequestConfig,
) {
	try {
		return await HttpHandler.Post<TOut>(buildUrl(controller, action), params, data, config);
	} catch (error) {
		log(error, "error");
		throw error;
	}
}

// oxlint-disable-next-line typescript/no-unnecessary-type-parameters -- callers pass explicit <TOut, TIn> type arguments
export async function Put<TOut, TIn = any>(
	controller: string,
	action: string,
	params: object | string = {},
	data?: TIn,
	config?: AxiosRequestConfig,
) {
	try {
		return await HttpHandler.Put<TOut>(buildUrl(controller, action), params, data, config);
	} catch (error) {
		log(error, "error");
		throw error;
	}
}

/** Make a GET request to the TLP server */
export async function Get<TOut>(
	controller: string,
	action: string,
	params: object | string = {},
	config?: AxiosRequestConfig,
) {
	try {
		return await HttpHandler.Get<TOut>(buildUrl(controller, action), params, config);
	} catch (error) {
		log(error, "error");
		throw error;
	}
}

export async function Ping<TOut>(controller: string, action: string) {
	try {
		return await HttpHandler.Ping<TOut>(buildUrl(controller, action));
	} catch (error) {
		log(error, "error");
		throw error;
	}
}

export async function Delete<TOut>(controller: string, action: string, id: number, config?: AxiosRequestConfig) {
	try {
		return await HttpHandler.Delete<TOut>(buildUrl(controller, action), id, config);
	} catch (error) {
		log(error, "error");
		throw error;
	}
}

/**
 * Joins the controller and action. Paths starting with `/` or `http` are used as-is, `MVC/` paths (any case) get a
 * leading slash, and anything else is prefixed with `/MVC/`.
 */
function buildUrl(controller: string, action: string) {
	const url = controller + (action ? `/${action}` : "");
	if (url.startsWith("/") || url.startsWith("http")) {
		return url;
	}

	if (url.toUpperCase().startsWith("MVC/")) {
		return `/${url}`;
	}

	return `/MVC/${url}`;
}

export type { HttpError } from "./httpHandler";

export default { Post, Put, Get, Delete, Ping, Handlers };
